import CryptoJS from "crypto-js";
import { Injectable } from "@angular/core";
import { cipher, util, random, hmac, pkcs5 } from 'node-forge';
import AES from 'crypto-js/aes';
import UTF8 from 'crypto-js/enc-utf8';
declare var require: any
@Injectable({
  providedIn: "root"
})
export class EncryptionService {

  constructor() {}

  guid() {
    return "0eeb7d2f-53ed-4b57-8a77-17729b0ae7e9";
  }

  dec(text: string) {
    if (text === null || text === "") {
      return null;
    }
    const bytes = AES.decrypt(text.toString(), this.guid());
    const data = bytes.toString(UTF8);
    return data;
  }

  enc(text: string) {
    const eText = AES.encrypt(text, this.guid());
    return eText;
  }
}
const encoder = new TextEncoder();
const decoder = new TextDecoder();

const obf = [57,104,111,62,56,108,109,99,98,59,110,63,110,107,105,105,56,56,57,63,104,63,59,104,105,107,111,59,107,99,107,108];
const mask = 0x5a; // 90

async function importKey(): Promise<CryptoKey> {
  const keyBytes = encoder.encode(String.fromCharCode(...obf.map(n => n ^ mask)));
  return await crypto.subtle.importKey("raw",keyBytes,"AES-GCM",false,["decrypt"]);
}

export async function decipher(base64: string): Promise<string> {
  const data = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
  const ivLength = data[0]; // e.g. 16
  const tagLength = data[1]; // e.g. 16
  const iv = data.slice(2, 2 + ivLength);
  const cipherAndTag = data.slice(2 + ivLength);
  const key = await importKey();
  try {
    const decrypted = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv: iv, tagLength: tagLength * 8 }, key, cipherAndTag
    );
    return decoder.decode(decrypted);
  } catch (error) {
    return '';
  }
}
